module.exports = __webpack_public_path__ + "static/header.64bf72fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/speaking/header.jpg
// module id = 171
// module chunks = 35783957827783 82206309271128